import { HttpClient } from '@angular/common/http';
import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from '@shared/handlers';
import { httpTranslateLoader } from '../translate-loader';

export const i18nProviders = [
  importProvidersFrom(
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
      },
    }),
  ),
  { provide: LOCALE_ID, useValue: 'es-CR' },
];
